// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.w-1[data-v-1a271ed6] {\n  width: 10%;\n}\n.w-2[data-v-1a271ed6] {\n  width: 30%;\n}\n.w-3[data-v-1a271ed6] {\n  width: 50%;\n}\n.w-4[data-v-1a271ed6] {\n  width: 70%;\n}\n.w-5[data-v-1a271ed6] {\n  width: 100%;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
